// extracted by mini-css-extract-plugin
export default {"container":"SearchImageInput-module__container--s1sCQ"};